const PRODUCT_DISPATCH_DAY_IN_MS = 24 * 60 * 60 * 1000;
const PRODUCT_DEFAULT_COUNTDOWN_TEMPLATE = 'Order in the next {time} for dispatch on {date}';
const PRODUCT_DISPATCH_WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const PRODUCT_DISPATCH_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

if (!customElements.get('product-information')) {
  customElements.define('product-information', class ProductInformation extends HTMLElement {
    staticBuyTools = true;
    quantityInput = undefined;
    onVariantChangeUnsubscriber = undefined;
    cartUpdateUnsubscriber = undefined;
    abortController = undefined;
    pendingRequestUrl = null;
    preProcessHtmlCallbacks = [];
    postProcessHtmlCallbacks = [];

    constructor() {
      super();
      this.dispatchCountdowns = new Map();
      this.dispatchCountdownCallbacksRegistered = false;
      this.buyToolsTrigger = this.querySelector('#product__buy-tools-trigger');
      this.productInfoContainer = this.querySelector('.product__info-container');
      this.onScrollToolsHandler = this.onScrollBuyTools.bind(this);
      this.quantityInput = this.querySelector(`#QuantityInput-${this.sectionId}`);

      this.initBreakpoints();
    }

    initBreakpoints() {
      const self = this;

      enquire.register('screen and (max-width: 1000px)', {
        match: () => {
          self.bpSmall = true;
          this.productInfoContainer.classList.remove('product__info-container--modal--out');
          this.productInfoContainer.classList.remove('product__info-container--modal', 'background-modal');
        },
        unmatch: () => {
          self.bpSmall = false;
          this.productInfoContainer.classList.remove('product__info-container--modal--out');
          this.productInfoContainer.classList.remove('product__info-container--modal', 'background-modal');
        }
      });
    }

    connectedCallback() {
      this.initializeProductSwapUtility();
      this.initializeDispatchCountdown(this);

      if (!this.dispatchCountdownCallbacksRegistered) {
        this.postProcessHtmlCallbacks.push((node) => this.initializeDispatchCountdown(node));
        this.dispatchCountdownCallbacksRegistered = true;
      }

      this.onVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this)
      );
    }

    addPreProcessCallback(callback) {
      this.preProcessHtmlCallbacks.push(callback);
    }

    disconnectedCallback() {
      this.onVariantChangeUnsubscriber();
      // this.cartUpdateUnsubscriber?.();
      this.teardownDispatchCountdowns();
    }

    initializeProductSwapUtility() {
      this.preProcessHtmlCallbacks.push((html) => {
        html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'));
      });
      this.postProcessHtmlCallbacks.push((newNode) => {
        window?.Shopify?.PaymentButton?.init();
        window?.ProductModel?.loadShopifyXR();
      });
    }

    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
      if (!this.contains(event.target)) return;

      this.resetProductFormState();

      const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
      this.pendingRequestUrl = productUrl;
      const shouldSwapProduct = this.dataset.url !== productUrl;
      const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
        targetId: target.id,
        callback: shouldSwapProduct
          ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
          : this.handleUpdateProductInfo(productUrl),
      });
    }

    resetProductFormState() {
      const productForm = this.productForm;
      this.toggleSubmitButton(true);
      productForm?.handleErrorMessage();
    }

    handleSwapProduct(productUrl, updateFullPage) {
      return (html) => {
        this.productModal?.remove();

        const selector = updateFullPage ? "product-information[id^='MainProduct']" : 'product-information';
        const variant = this.getSelectedVariant(html.querySelector(selector));
        this.updateURL(productUrl, variant?.id);

        if (updateFullPage) {
          document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

          HTMLUpdateUtility.viewTransition(
            document.querySelector('main'),
            html.querySelector('main'),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );
        } else {
          HTMLUpdateUtility.viewTransition(
            this,
            html.querySelector('product-information'),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );
        }
      };
    }

    renderProductInfo({ requestUrl, targetId, callback }) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          callback(html);
        })
        .then(() => {
          // set focus to last clicked option value
          document.querySelector(`#${targetId}`)?.focus();
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          } else {
            console.error(error);
          }
        });
    }

    getSelectedVariant(productInfoNode) {
      const selector = 'variant-selects [data-selected-variant]';

      const selectedVariant = productInfoNode.querySelector(`${selector}`)?.innerHTML;
      return !!selectedVariant ? JSON.parse(selectedVariant) : null;
    }

    buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
      const params = [];

      !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(',')}`);
      }

      return `${url}?${params.join('&')}`;
    }

    updateOptionValues(html) {
      const sectionId = `${this.sectionId}${this.blockId ? `${this.blockId}`: ''}`;
      const variantSelects = html.getElementById(`VariantSelect-${sectionId}`);

      if (variantSelects) {
        const isOnProductModal =
          this.closest('complementary-products-card') ||
          this.closest('quick-add-modal') ||
          this.closest('.shop-look__item-wrap');
        if (isOnProductModal) {
          const updatedOptions = variantSelects.querySelectorAll('fieldset');

          this.variantSelectors.querySelectorAll('input[data-disabled="true"]').forEach((i) => {
            i.removeAttribute('data-disabled');
          });

          updatedOptions.forEach((option) => {
            option.querySelectorAll('input[data-disabled="true"]').forEach((i) => {
              const inputId = i.dataset.optionValueId;
              const currentNode = this.variantSelectors.querySelector(`input[data-option-value-id="${inputId}"]`);
              if (currentNode?.tagName === 'INPUT' && currentNode?.type === 'radio') {
                currentNode.setAttribute('data-disabled', 'true');
              }
            });
          });
        } else {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }
    }

    handleUpdateProductInfo(productUrl) {
      return (html) => {
        const variant = this.getSelectedVariant(html);
        const sectionId = `${this.sectionId}${this.blockId ? `${this.blockId}`: ''}`;

        this.pickupAvailability?.update(variant);
        this.updateOptionValues(html);
        this.updateURL(productUrl, variant?.id);
        this.updateVariantInputs(variant?.id);

        if (!variant) {
          this.setUnavailable();
          return;
        }

        this.updateMedia(variant, variant?.featured_media?.id);

        const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
          const source = html.getElementById(`${id}-${sectionId}`);
          const destination = this.querySelector(`#${id}-${this.dataset.section}`);
          if (source && destination) {
            destination.innerHTML = source.innerHTML;
            destination.classList.toggle('visibility-hidden', shouldHide(source));
          }
        };

        updateSourceFromDestination('price');
        updateSourceFromDestination('sku', ({ classList }) => classList.contains('visibility-hidden'));
        updateSourceFromDestination('StockNotification', ({ innerText }) => innerText === '');

        this.updateLimitQuantity(this.sectionId, html);

        this.toggleSubmitButton(
          html.getElementById(`ProductSubmitButton-${sectionId}`)?.hasAttribute('disabled') ?? true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            html,
            variant,
          },
        });
      };
    }

    updateLimitQuantity(sectionId, html) {
      if (!this.quantityInput) return;
      const quantityFormUpdated = html.getElementById(`QuantityInput-${sectionId}`);

      this.quantityInput.updateLimitQuantity(quantityFormUpdated);
    }

    updateVariantInputs(variantId) {
      const sectionId = `${this.dataset.section}`;

      this.querySelectorAll(
        `#product-form-${sectionId}, #product-form-installment-${sectionId}`
      ).forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = variantId ?? '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updateURL(url, variantId) {
      this.querySelector('share-button')?.updateUrl(
        `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
      );

      if (this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
    }

    toggleSubmitButton(disable = true, text) {
      const productForm = this.productForm?.querySelector('form');
      if (!productForm) return;

      const addButton = productForm.querySelector('[data-add-to-cart]');
      const addButtonText = productForm.querySelector('[data-add-to-cart-text]');
      if (!addButton) return;

      const variantClassSoldOut = 'product-form--variant-sold-out';
      const formParentElement = productForm.closest('.product-form__buy-buttons');
      const productMetaPrice = formParentElement ? formParentElement.querySelector('[data-product-meta-price]') : null;

      if (disable) {
        addButton.setAttribute('aria-disabled', true);
        addButton.setAttribute('disabled', true);
        addButton.setAttribute('aria-label', text);
        if (text) {
          addButtonText.textContent = text;
          productForm.classList.add(variantClassSoldOut);
          if (productMetaPrice) productMetaPrice.classList.add('meta-price--hidden');
        }
      } else {
        addButton.removeAttribute('aria-disabled');
        addButton.removeAttribute('disabled');
        addButton.setAttribute('aria-label', window.variantStrings.addToCart);
        addButtonText.textContent = window.variantStrings.addToCart;
        productForm.classList.remove(variantClassSoldOut);
        if (productMetaPrice) productMetaPrice.classList.remove('meta-price--hidden');
      }
    }

    setUnavailable() {
      this.toggleSubmitButton(true, window.variantStrings.unavailable);

      const selectors = ['price', 'sku', 'StockNotification']
        .map((id) => `#${id}-${this.dataset.section}`)
        .join(', ');

      document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('visibility-hidden'));
    }

    updateMedia(variant, variantFeaturedMediaId) {
      if (!variantFeaturedMediaId) return;

      const sectionId = `${this.dataset.section}`;
      const mediaGallery = this.querySelector(`#MediaGallery-${sectionId}`);
      if (!mediaGallery) return;
      mediaGallery.setActiveMedia(`${sectionId}-${variantFeaturedMediaId}`, variant);
    }

    buyToolsCalculations() {
      this.staticBuyTools = false;
      this.productPageSection = this.parentElement;
      this.productInfoWrapper = this.productPageSection.querySelector('.product__info-wrapper');
      this.productInfoContainerHeight = this.productInfoContainer.offsetHeight;
      this.negativeHeight = this.productInfoContainerHeight * -1;
      this.productContentSection = document.querySelector('.product-content-section');

      const productContentMinHeight = this.productInfoContainerHeight - this.productPageSection.offsetHeight + 54;
      this.productContentSection.style.minHeight = `${productContentMinHeight}px`;

      this.resizeProductInfoObserver = new ResizeObserver((entries) => {
        if (this.bpSmall) return;
        if (!this.productInfoContainer.classList.contains('product__info-container--modal')) {
          const productInfoContainerHeight = this.productInfoContainer.offsetHeight;
          if (productInfoContainerHeight != this.productInfoContainerHeight) {
            this.productInfoContainerHeight = productInfoContainerHeight;
            const productContentMinHeight = productInfoContainerHeight - this.productPageSection.offsetHeight + 54;
            this.productContentSection.style.minHeight = `${productContentMinHeight}px`;

            this.negativeHeight = productInfoContainerHeight * -1;
          }
        }
      });

      this.resizeProductInfoObserver.observe(this.productInfoContainer);
    }

    onScrollBuyTools() {
      if (this.bpSmall || !this.buyToolsTrigger ) return;

      const triggerTop = this.buyToolsTrigger.getBoundingClientRect().top;
      const buyToolsModalActive = this.productInfoContainer.classList.contains('product__info-container--modal', 'background-modal');
      const bytToolsModalOut = this.productInfoContainer.classList.contains('product__info-container--modal--out');

      if (triggerTop < this.negativeHeight && !buyToolsModalActive) {
        requestAnimationFrame(() => {
          this.productInfoContainer.classList.add('product__info-container--modal', 'background-modal');
        });
      } else if (triggerTop > this.negativeHeight && buyToolsModalActive && !bytToolsModalOut) {
        requestAnimationFrame(() => {
          this.productInfoContainer.classList.add('product__info-container--modal--out');

          this.productInfoContainer.addEventListener('animationend', () => {
            this.productInfoContainer.classList.remove('product__info-container--modal--out');
            this.productInfoContainer.classList.remove('product__info-container--modal', 'background-modal');
          }, { once: true });
        });
      }
    }

    get productForm() {
      return this.querySelector(`product-form`);
    }

    get productModal() {
      return document.querySelector(`#ProductModal-${this.sectionId}`);
    }

    get pickupAvailability() {
      return this.querySelector(`pickup-availability`);
    }

    get variantSelectors() {
      return this.querySelector('variant-selects');
    }

    get relatedProducts() {
      const relatedProductsSectionId = SectionId.getIdForSection(
        SectionId.parseId(this.sectionId),
        'related-products'
      );
      return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
    }

    get sectionId() {
      return this.dataset.originalSection || this.dataset.section;
    }

    get blockId() {
      return this.dataset.block;
    }

    initializeDispatchCountdown(root = this) {
      this.teardownDispatchCountdowns();

      const searchRoot =
        root instanceof Element || root instanceof DocumentFragment ? root : this;

      const elements = searchRoot.querySelectorAll
        ? Array.from(searchRoot.querySelectorAll('[data-dispatch-countdown]'))
        : [];

      if (!elements.length) {
        return;
      }

      elements.forEach((element) => this.setupDispatchCountdown(element));
    }

    setupDispatchCountdown(element) {
      if (!this.dispatchCountdowns) {
        this.dispatchCountdowns = new Map();
      }

      const existingTimer = this.dispatchCountdowns.get(element);
      if (existingTimer) {
        const timerId =
          typeof existingTimer === 'number' ? existingTimer : existingTimer.timerId;
        window.clearInterval(timerId);
        this.dispatchCountdowns.delete(element);
      }

      const dataset = element.dataset || {};
      const countdownTarget = element.querySelector('[data-countdown-text]') || element;
      const fallbackMessage = (dataset.fallback || 'Order by 5pm for same-day dispatch.').trim();
      const templateValue = dataset.template ? dataset.template.trim() : '';
      const template = templateValue.length
        ? templateValue
        : PRODUCT_DEFAULT_COUNTDOWN_TEMPLATE;
      const cutoffHourValue = Number(dataset.cutoffHour);
      const cutoffMinuteValue = Number(dataset.cutoffMinute);
      const cutoffHour = Number.isFinite(cutoffHourValue) ? cutoffHourValue : 17;
      const cutoffMinute = Number.isFinite(cutoffMinuteValue) ? cutoffMinuteValue : 0;
      const offsetMinutes = this.parseTimezoneOffset(dataset.timezoneOffset);
      const templateTokens = this.parseCountdownTemplate(template);

      if (Number.isNaN(offsetMinutes)) {
        countdownTarget.textContent = fallbackMessage;
        return;
      }

      countdownTarget.setAttribute('aria-live', 'polite');
      countdownTarget.setAttribute('role', 'text');

      const renderCountdown = () => {
        const countdown = this.calculateDispatchCountdown({
          offsetMinutes,
          cutoffHour,
          cutoffMinute,
        });

        if (!countdown) {
          countdownTarget.textContent = fallbackMessage;
          countdownTarget.removeAttribute('aria-live');
          countdownTarget.removeAttribute('role');
          return;
        }

        const message = this.applyTemplatePlaceholders(template, countdown);
        const hasTimePlaceholder = /{{\s*time\s*}}|{\s*time\s*}/i.test(template);
        const hasDatePlaceholder = /{{\s*date\s*}}|{\s*date\s*}/i.test(template);
        const accessibleMessage =
          hasTimePlaceholder && hasDatePlaceholder
            ? message
            : `${message ? `${message} ` : ''}${this.applyTemplatePlaceholders(
                PRODUCT_DEFAULT_COUNTDOWN_TEMPLATE,
                countdown
              )}`.trim();

        this.renderCountdownMarkup({
          target: countdownTarget,
          tokens: templateTokens,
          countdown,
          ariaMessage: accessibleMessage,
        });
      };

      renderCountdown();

      const timerId = window.setInterval(renderCountdown, 1000);
      this.dispatchCountdowns.set(element, { timerId });
    }

    calculateDispatchCountdown({ offsetMinutes, cutoffHour, cutoffMinute }) {
      if (Number.isNaN(offsetMinutes)) {
        return null;
      }

      const normalizedCutoffHour = Number.isFinite(cutoffHour) ? cutoffHour : 17;
      const normalizedCutoffMinute = Number.isFinite(cutoffMinute) ? cutoffMinute : 0;

      const storeNowMs = Date.now() + offsetMinutes * 60000;
      const cutoffTodayMs = this.getCutoffTimeMs(
        storeNowMs,
        normalizedCutoffHour,
        normalizedCutoffMinute
      );

      let dispatchDateMs = storeNowMs;
      let targetCutoffMs = cutoffTodayMs;

      if (storeNowMs >= cutoffTodayMs) {
        dispatchDateMs += PRODUCT_DISPATCH_DAY_IN_MS;
        targetCutoffMs += PRODUCT_DISPATCH_DAY_IN_MS;
      }

      const diffMs = Math.max(0, targetCutoffMs - storeNowMs);
      const duration = this.formatDuration(diffMs);

      return {
        time: duration.verbose,
        timeDigital: duration.digital,
        hours: duration.hours,
        minutes: duration.minutes,
        seconds: duration.seconds,
        date: this.formatStoreDate(dispatchDateMs),
      };
    }

    getCutoffTimeMs(storeNowMs, cutoffHour, cutoffMinute) {
      const cutoffDate = new Date(storeNowMs);
      cutoffDate.setUTCHours(cutoffHour, cutoffMinute, 0, 0);
      return cutoffDate.getTime();
    }

    formatDuration(diffMs) {
      const totalSeconds = Math.floor(diffMs / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const pad = (value) => String(value).padStart(2, '0');

      const paddedHours = pad(hours);
      const paddedMinutes = pad(minutes);
      const paddedSeconds = pad(seconds);

      return {
        hours: paddedHours,
        minutes: paddedMinutes,
        seconds: paddedSeconds,
        digital: `${paddedHours}:${paddedMinutes}:${paddedSeconds}`,
        verbose: `${paddedHours} hrs ${paddedMinutes} mins ${paddedSeconds} secs`,
      };
    }

    applyTemplatePlaceholders(template, countdown) {
      if (!template || typeof template !== 'string') {
        return '';
      }

      return template
        .replace(/{{\s*time\s*}}/gi, countdown.time)
        .replace(/{\s*time\s*}/gi, countdown.time)
        .replace(/{{\s*date\s*}}/gi, countdown.date)
        .replace(/{\s*date\s*}/gi, countdown.date);
    }

    parseCountdownTemplate(template) {
      const source = typeof template === 'string' && template.length
        ? template
        : PRODUCT_DEFAULT_COUNTDOWN_TEMPLATE;
      const placeholderRegex = /({{\s*(time|date)\s*}}|{\s*(time|date)\s*})/gi;
      const tokens = [];
      let currentIndex = 0;
      let match;

      while ((match = placeholderRegex.exec(source)) !== null) {
        if (match.index > currentIndex) {
          tokens.push({
            type: 'text',
            value: source.slice(currentIndex, match.index),
          });
        }

        const placeholderType = (match[2] || match[3] || '').toLowerCase();
        tokens.push({
          type: placeholderType === 'date' ? 'date' : 'time',
        });
        currentIndex = match.index + match[0].length;
      }

      if (currentIndex < source.length) {
        tokens.push({
          type: 'text',
          value: source.slice(currentIndex),
        });
      }

      const hasTime = tokens.some((token) => token.type === 'time');
      const hasDate = tokens.some((token) => token.type === 'date');
      const normalizedTokens = [...tokens];

      if (!hasTime) {
        normalizedTokens.unshift({ type: 'time' });
      }

      if (!hasDate) {
        if (normalizedTokens.length) {
          normalizedTokens.push({ type: 'text', value: ' ' });
        }
        normalizedTokens.push({ type: 'date' });
      }

      return normalizedTokens;
    }

    renderCountdownMarkup({ target, tokens, countdown, ariaMessage }) {
      if (!target) {
        return;
      }

      const safeTokens = Array.isArray(tokens) && tokens.length
        ? tokens
        : this.parseCountdownTemplate(PRODUCT_DEFAULT_COUNTDOWN_TEMPLATE);

      target.innerHTML = '';

      if (ariaMessage) {
        const srText = document.createElement('span');
        srText.className = 'visually-hidden';
        srText.textContent = ariaMessage;
        target.appendChild(srText);
      }

      const wrapper = document.createElement('span');
      wrapper.className = 'product-countdown';

      if (ariaMessage) {
        wrapper.setAttribute('aria-hidden', 'true');
      }

      safeTokens.forEach((token) => {
        if (token.type === 'text') {
          if (!token.value) {
            return;
          }
          const textSpan = document.createElement('span');
          textSpan.className = 'product-countdown__text';
          textSpan.textContent = token.value;
          wrapper.appendChild(textSpan);
        } else if (token.type === 'time') {
          wrapper.appendChild(this.createCountdownTimer(countdown));
        } else if (token.type === 'date') {
          wrapper.appendChild(this.createCountdownDate(countdown.date));
        }
      });

      target.appendChild(wrapper);
    }

    createCountdownTimer(countdown) {
      const timer = document.createElement('span');
      timer.className = 'product-countdown__timer';
      timer.setAttribute('aria-hidden', 'true');

      const blocks = [
        { key: 'hours', label: 'hrs' },
        { key: 'minutes', label: 'mins' },
        { key: 'seconds', label: 'secs' },
      ];

      blocks.forEach(({ key, label }) => {
        timer.appendChild(
          this.createCountdownTimeBlock(
            countdown[key],
            label,
            key,
          ),
        );
      });

      return timer;
    }

    createCountdownDate(dateString) {
      const dateElement = document.createElement('strong');
      dateElement.className = 'product-countdown__date';
      dateElement.textContent = dateString;
      dateElement.dataset.countdownDate = '';
      dateElement.setAttribute('aria-hidden', 'true');
      return dateElement;
    }

    createCountdownTimeBlock(value, label, key) {
      const block = document.createElement('span');
      block.className = 'product-countdown__time-block';

      const digits = document.createElement('span');
      digits.className = 'product-countdown__time-digits';
      digits.textContent = typeof value === 'string' && value.length ? value : '00';
      const datasetKey = `countdown${key.charAt(0).toUpperCase()}${key.slice(1)}`;
      digits.dataset[datasetKey] = '';

      const caption = document.createElement('span');
      caption.className = 'product-countdown__time-label';
      caption.textContent = label;

      block.appendChild(digits);
      block.appendChild(caption);

      return block;
    }

    formatStoreDate(storeMs) {
      const date = new Date(storeMs);
      const weekday = PRODUCT_DISPATCH_WEEKDAYS[date.getUTCDay()];
      const month = PRODUCT_DISPATCH_MONTHS[date.getUTCMonth()];
      const day = date.getUTCDate();

      return `${weekday} ${this.formatOrdinal(day)} ${month}`;
    }

    formatOrdinal(value) {
      const normalized = Math.abs(Math.trunc(value));
      const mod100 = normalized % 100;

      if (mod100 >= 11 && mod100 <= 13) {
        return `${normalized}th`;
      }

      switch (normalized % 10) {
        case 1:
          return `${normalized}st`;
        case 2:
          return `${normalized}nd`;
        case 3:
          return `${normalized}rd`;
        default:
          return `${normalized}th`;
      }
    }

    parseTimezoneOffset(offset = '+0000') {
      const match = /^([+-])(\d{2})(\d{2})$/.exec(offset || '');
      if (!match) {
        return 0;
      }

      const [, sign, hours, minutes] = match;
      const totalMinutes = Number(hours) * 60 + Number(minutes);
      return sign === '-' ? -totalMinutes : totalMinutes;
    }

    teardownDispatchCountdowns() {
      if (!this.dispatchCountdowns) {
        return;
      }

      this.dispatchCountdowns.forEach((timerOrObject) => {
        const timerId =
          typeof timerOrObject === 'number' ? timerOrObject : timerOrObject.timerId;
        window.clearInterval(timerId);
      });
      this.dispatchCountdowns.clear();
    }

    get productId() {
      return this.dataset.productId;
    }
  });
}
